import React, { useEffect } from 'react'
import { useAccountTypes } from '../AccountTypeContext'
import CreditCard from './CreditCard'
import { useHostServices } from '../HostServices'
import PartialOutageNotice from '../Shared/partialOutageNotice'
import StaleDataNotice from '../Shared/StaleDataNotice'
import LobShell from '../Shared/LobShell'
import { customErrorAnalytics } from '../analytics'

const CreditCards = (): JSX.Element | null => {
  const {
    hasCCAccounts,
    hasStaleCCAccounts,
    isCCFullOutage,
  } = useAccountTypes()
  const { featureFlags } = useHostServices()
  const isCCEnabled = featureFlags.variation('FF_credit-card-snapshot', false)

  useEffect((): void => {
    if (isCCFullOutage) {
      customErrorAnalytics('Credit Card Outage')
    }
  }, [isCCFullOutage])

  if (!isCCEnabled || (!hasCCAccounts && !isCCFullOutage)) {
    return null
  }

  return (
    <LobShell header="Credit Cards" customizeTriggerLob="CC">
      {hasStaleCCAccounts && <StaleDataNotice dataTestId="stale-cc-notice" />}
      {isCCFullOutage ? <PartialOutageNotice lob="CC" /> : <CreditCard />}
    </LobShell>
  )
}

export default CreditCards
